import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/dashboard'

export default {
  namespaced: true,
  state: {
    cacheInfo: [],
    loadings: {
      counters: false,
      yearlyCount: false,
      brandsCount: false,
      brandsWorks: false,
      brandsDayWorks: false,
      serviceTurnovers: false,
      serviceGoals: false,
    },
    dashboardData: {
      counters: {
        mtdTurnover: 0,
        serviceWorks: {
          open: 0,
          closed: 0,
        },
        mtdCount: 0,
        serviceWorkDurationAVG: 0,
      },
      yearlyCount: {
        series: [],
        categories: [],
      },
      brandsCount: {
        series: [],
        labels: [],
        colors: [],
      },
      brandsWorks: {
        series: [],
      },
      brandsDayWorks: {
        series: [],
        categories: [],
        colors: [],
      },
      serviceTurnovers: {
        series: [],
        categories: [],
        colors: [],
      },
      serviceGoals: [],
    },
  },
  getters: {
    cacheInfo(state) {
      return state.cacheInfo
    },
    loadings(state) {
      return state.loadings
    },
    dashboardData(state) {
      return state.dashboardData
    },
  },
  mutations: {
    SET_LOADINGS(state, data) {
      if (data.type === 'counters') {
        state.loadings.counters = data.status
      }
      if (data.type === 'yearlyCount') {
        state.loadings.yearlyCount = data.status
      }
      if (data.type === 'brandsCount') {
        state.loadings.brandsCount = data.status
      }
      if (data.type === 'brandsWorks') {
        state.loadings.brandsWorks = data.status
      }
      if (data.type === 'brandsDayWorks') {
        state.loadings.brandsDayWorks = data.status
      }
      if (data.type === 'serviceTurnovers') {
        state.loadings.serviceTurnovers = data.status
      }
      if (data.type === 'serviceGoals') {
        state.loadings.serviceGoals = data.status
      }
    },

    SET_DASHBOARD_DATA(state, data) {
      if (data.type === 'counters') {
        state.dashboardData.counters = data.data
      }
      if (data.type === 'yearlyCount') {
        state.dashboardData.yearlyCount = data.data
      }
      if (data.type === 'brandsCount') {
        state.dashboardData.brandsCount = data.data
      }
      if (data.type === 'brandsWorks') {
        state.dashboardData.brandsWorks = data.data
      }
      if (data.type === 'brandsDayWorks') {
        state.dashboardData.brandsDayWorks = data.data
      }
      if (data.type === 'serviceTurnovers') {
        state.dashboardData.serviceTurnovers = data.data
      }
      if (data.type === 'serviceGoals') {
        state.dashboardData.serviceGoals = data.data
      }
    },
    SET_CACHE_INFO(state, data) {
      state.cacheInfo = data
    },
    /* RESET MUTATIONS */
    RESET_DASHBOARD_DATA(state) {
      state.dashboardData = {
        counters: {
          mtdTurnover: 0,
          serviceWorks: {
            open: 0,
            closed: 0,
          },
          mtdCount: 0,
          serviceWorkDurationAVG: 0,
        },
        yearlyCount: {
          series: [],
          categories: [],
        },
        brandsCount: {
          series: [],
          labels: [],
          colors: [],
        },
        brandsWorks: {
          series: [],
        },
        brandsDayWorks: {
          series: [],
          categories: [],
          colors: [],
        },
        serviceTurnovers: {
          series: [],
          categories: [],
          colors: [],
        },
        serviceGoals: [],
      }
    },
  },
  actions: {
    getData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/serviceLive?type=${params.type}`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
    refreshData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/serviceLive?type=${params.type}&noCache=true`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
  },
}
